import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  ButtonGroup,
  Modal,
  ControlLabel,
  Row,
  Col,
  Glyphicon,
  Checkbox,
  Radio,
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import {
  getArchivevoucherList,
  updateStatus,
  voucherTransfer,
  getVoucherDetail,
  refundVoucher,
  resendarchiveVoucher,
} from "../../../redux/actions/voucherActions";
import moment from "moment";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { allUser } from "../../../redux/actions/subAdminActions";
import { getFrontPaymentSetting } from "../../../redux/actions/payemntSettingAction";
import { aclUtil } from "../../util";

const history = createBrowserHistory();

let isLoading = "false";
class ArchivevouchersList extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);

    this.state = {
      voucherData: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      page: 1,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      menuKey: "LIST_VOUCHERS",
      path: ["Home", "Manage Archive Vouchers List"],
      links: ["home", "archivevoucherList"],
      show: false,
      voucherNumberSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      dealTextSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      statusSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      direction: "DESC",
      orderBy: "createdOn",
      showDialog: false,
      promoid: "",
      show: false,
      note: "",
      voucherID: "",
      status: "",
      popUpStatus: false,
      popUpTransfer: false,
      searchValue: "",
      userList: "",
      popUpTransfer: false,
      popUpRefund: false,
      voucherDetail: "",
      amount: "",
      refundAs: "StoreCredit",
      sendRefundMail: "yes",
      reason: "",
      quantity: "",
      vouchers: "",
      transactions: "",
      checkedValues: [],
      userID: "",
      date: new Date(),
      userEmail: "",
      startDate: "",
      range: false,
      offerIDs: "",
      merchantIDs: "",
      refundtype: "instock",
      stripeStatus: false,
      authStatus: false,
      payPalStatus: false,
      chaseStatus: false,
      paywayStatus: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.resendVoucher = this.resendVoucher.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleVoucherList = this.handleVoucherList.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }

  // onChangeStartDate = (date) => {
  //   this.setState({ startDate: date });
  // };

  onChangeStartDate = (selectedDate) => {
    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
      this.setState({
        startDate: selectedDate,
      });
    } else if (selectedDate === null) {
      this.setState({
        startDate: "",
      });
    } else {
    }
  };

  onChangeStartDateRange = (date) => {
    let dateSet = {
      startDateRange: date,
      startDate: "",
      endDate: "",
    };
    if (date && date[0]) {
      dateSet.startDate = date[0];
    }
    if (date && date[1]) {
      dateSet.endDate = date[1];
    }
    this.setState(dateSet);
  };

  changeDatePicker = (status) => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  transferVoucher = (userID) => {
    isLoading = "true";
    const postData = {
      voucherID: this.state.transferVoucherID,
      userID: userID,
    };

    this.props.voucherTransfer(postData);
  };

  handleSearch = (e) => {
    this.setState({ [e.target.name]: e.target.value, searchValueError: "" });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    this.handleVoucherList({ search: searchstring });
  };

  handleUserSearch = (e) => {
    e.preventDefault();
    if (!this.state.searchValue) {
      this.setState({ searchValueError: "red" });
    } else {
      isLoading = "true";
      this.props.allUser({ search: this.state.searchValue });
    }
  };

  handleTransfer = (voucherID) => {
    this.setState({
      popUpTransfer: true,
      transferVoucherID: voucherID,
    });
  };

  resendVoucher = (e) => {
    isLoading = "true";
    let voucherID = e.target.attributes.getNamedItem("data-id").value;
    this.props.resendarchiveVoucher({ voucherID: voucherID });
  };

  ClosePopupTransfer = (e) => {
    this.setState({
      popUpTransfer: false,
      transferVoucherID: "",
      searchValue: "",
      userList: "",
    });
  };

  handleRefund = (voucherID) => {
    isLoading = "true";
    this.props.getVoucherDetail(voucherID);
    this.setState({
      transferVoucherID: voucherID,
    });
  };

  CloseRefundPopup = (e) => {
    this.setState({
      popUpRefund: false,
      voucherDetail: "",
      amount: "",
      refundAs: "StoreCredit",
      sendRefundMail: "yes",
      reason: "",
      quantity: "",
      vouchers: "",
      transactions: "",
      checkVoucherError: "",
      reasonError: "",
      stripeStatus: false,
      authStatus: false,
      payPalStatus: false,
      chaseStatus: false,
      paywayStatus: false,
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePageChange = (page) => {
    this.setState({
      currentPage: page,
    });
    this.handleVoucherList({
      page: page,
    });
  };

  handleSort = (orderBy) => (e) => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy,
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy,
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy,
      });
    }
    this.setState({ orderBy: orderBy, direction: direction });
    this.handleVoucherList({ orderBy: orderBy, direction: direction });
  };

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ currentPage: 1 });
    this.handleVoucherList({ page: 1 });
  }

  handleVoucherList(formData) {
    const stateData = {
      startDate: this.state.startDate
        ? moment(this.state.startDate).format("YYYY-MM-DD")
        : "",
      endDate: this.state.endDate
        ? moment(this.state.endDate).format("YYYY-MM-DD")
        : "",
      offerIDs: this.state.offerIDs,
      merchantIDs: this.state.merchantIDs,
      limit: this.state.limit,
      page: this.state.currentPage,
      userID: this.state.userID,
      userEmail: this.state.userEmail,
      search: this.state.search ? this.state.search : "",
      orderBy: this.state.orderBy,
      direction: this.state.direction,
    };
    formData = { ...stateData, ...formData };
    this.props.getArchivevoucherList(formData);
  }

  componentDidMount() {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.userId &&
      this.props.match.params.userId.length > 0
    ) {
      this.setState({
        userID: this.props.match.params.userId,
        currentPage: 1,
      });
      this.handleVoucherList({
        page: 1,
        userID: this.props.match.params.userId,
      });
    } else {
      this.handleVoucherList();
    }
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      this.props.getFrontPaymentSetting({ lang: siteData.default_lang });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)) {
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.archivevoucherlist !== nextProps.archivevoucherlist) {
      if (nextProps.archivevoucherlist) {
        isLoading = "false";
        const setPageCount =
          nextProps.archivevoucherlist.data.total /
          nextProps.archivevoucherlist.data.per_page;
        this.setState({
          voucherData: nextProps.archivevoucherlist.data.data,
          totalRecords: nextProps.archivevoucherlist.data.total,
          perPage: nextProps.archivevoucherlist.data.per_page,
          pageCount: setPageCount,
        });
      }
    }

    if (this.props.voucherDetails !== nextProps.voucherDetails) {
      if (nextProps.voucherDetails) {
        if (nextProps.voucherDetails.data) {
          isLoading = "false";
        }
        let offerdata = nextProps.voucherDetails.data;
        let checkVoucher = [];
        this.props.getFrontPaymentSetting();
        if (!isEmpty(nextProps.voucherDetails.data.vouchers)) {
          nextProps.voucherDetails.data.vouchers.map((data, index) => {
            if (data.status == "Active") {
              checkVoucher.push(data.voucherID);
            }
          });
        }

        this.setState({
          voucherDetail: offerdata,
          popUpRefund: true,
          amount: nextProps.voucherDetails.data.voucherValue,
          quantity: nextProps.voucherDetails.data.quantity,
          transactions: nextProps.voucherDetails.data.transactions,
          vouchers: nextProps.voucherDetails.data.vouchers,
          checkVoucher: checkVoucher,
        });

        let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
        if (siteData) {
          this.props.getFrontPaymentSetting({ lang: siteData.default_lang });
        }
      }
    }

    if (this.props.paymentSetting !== nextProps.paymentSetting) {
      if (nextProps.paymentSetting) {
        let data = nextProps.paymentSetting.data;
        if (data.allowPaymentAuthRefunds == 1) {
          this.setState({ authStatus: true });
        }
        if (data.allowPaymentPaypalRefunds == 1) {
          this.setState({ payPalStatus: true });
        }
        if (data.allowPaymentChaseRefunds == 1) {
          this.setState({ chaseStatus: true });
        }
        if (data.allowPaymentPaywayRefunds == 1) {
          this.setState({ paywayStatus: true });
        }
        if (data.allowPaymentStripeRefunds == 1) {
          this.setState({ stripeStatus: true });
        }
      }
    }

    if (this.props.userList !== nextProps.userList) {
      isLoading = "false";
      if (nextProps.userList) {
        isLoading = "false";
        this.setState({
          userList: nextProps.userList.data,
        });
      }
    }

    if (this.props.transfer !== nextProps.transfer) {
      if (nextProps.transfer) {
        this.props.clearAlert();
        this.handleShow();
        isLoading = "false";
        this.ClosePopupTransfer();
        this.handleVoucherList();
        this.props.renderAlert(
          nextProps.transfer.response,
          nextProps.transfer.message
        );
        window.scrollTo(0, 0);
      }
    }

    if (this.props.refundStatus !== nextProps.refundStatus) {
      if (nextProps.refundStatus) {
        this.props.clearAlert();
        this.handleShow();
        isLoading = "false";
        this.CloseRefundPopup();
        this.handleVoucherList();
        // this.props.getarchivevoucherList({
        //   page: this.state.currentPage,
        //   limit: this.state.limit,
        //   userID: this.state.userID,
        // });
        this.props.renderAlert(
          nextProps.refundStatus.response,
          nextProps.refundStatus.message
        );
        window.scrollTo(0, 0);
      }
    }

    if (this.props.resendStatus !== nextProps.resendStatus) {
      if (nextProps.resendStatus) {
        this.props.clearAlert();
        this.handleShow();
        isLoading = "false";
        this.handleVoucherList();
        // this.props.getarchivevoucherList({
        //   page: this.state.currentPage,
        //   limit: this.state.limit,
        //   userID: this.state.userID,
        // });
        this.props.renderAlert(
          nextProps.resendStatus.response,
          nextProps.resendStatus.message
        );
        window.scrollTo(0, 0);
      }
    }

    if (this.props.voucherStatus !== nextProps.voucherStatus) {
      if (nextProps.voucherStatus) {
        this.props.clearAlert();
        this.handleShow();

        if (nextProps.voucherStatus && nextProps.voucherStatus.message) {
          isLoading = "false";
          this.setState({ popUpStatus: false, status: "", voucherID: "" });
          this.handleVoucherList();
          //this.props.getarchivevoucherList({
          // page: this.state.currentPage,
          // //limit: this.state.limit,
          //userID: this.state.userID,
          //  });
          this.props.renderAlert(
            nextProps.voucherStatus.response,
            nextProps.voucherStatus.message
          );
          window.scrollTo(0, 0);
        }
      }
    }
    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        this.CloseRefundPopup();
        window.scrollTo(0, 0);
      }
    }
  }

  handleNoteChange = (e) => {
    this.setState({ note: e.target.value, noteError: "" });
  };

  handleStatus = (e) => {
    if (this.state.note) {
      this.handleShow();
      isLoading = "true";
      let postdata = {
        status: this.state.status,
        note: this.state.note,
      };
      // this.setState({note:"", noteError:""});
      this.props.updateStatus(this.state.voucherID, postdata);
    } else {
      this.setState({ noteError: "red" });
    }
  };

  ClosePopup = (e) => {
    this.setState({ popUpStatus: false, status: "", voucherID: "" });
  };
  changeStatus = (voucherID, status) => {
    this.setState({ popUpStatus: true, status: status, voucherID: voucherID });
  };

  handleChange = (e) => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  };

  handleCheck(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: "yes" });
    } else {
      this.setState({ [e.target.name]: "no" });
    }
  }

  refundProcess = (e, isrefund = false) => {
    e.preventDefault();
    if (this.state.refundAs == "OfflineRefund" && !isrefund) {
      this.dialog.show({
        body: "This refund would be  done via cash/check, no action from payment gateway would be done. Please click on the Ok button to continue.",
        actions: [
          Dialog.CancelAction(),
          Dialog.OKAction(() => {
            this.refundProcess(e, true);
          }),
        ],
      });
    } else {
      isrefund = true;
    }
    let valid = this.validate();
    isLoading = "false";
    if (valid && isrefund) {
      const constData = {
        refundAs: this.state.refundAs,
        amount: this.state.amount
          ? this.state.amount
          : this.state.voucherDetail.voucherValue,
        status: "refund",
        voucherStatus: this.state.voucherDetail.status,
        reason: this.state.reason,
        refundtype: this.state.refundtype,
        sendRefundMail: this.state.sendRefundMail,
        voucherID: this.state.checkVoucher,
        checkVoucherError: "",
      };
      this.props.refundVoucher(constData);
    }
  };

  validate = (e) => {
    let returnValue = true;

    if (!this.state.reason) {
      returnValue = false;
      this.setState({ reasonError: "red" });
    }

    if (
      isEmpty(this.state.checkVoucher) &&
      this.state.checkVoucher.length == 0
    ) {
      returnValue = false;
      this.setState({
        checkVoucherError: "Minimum 1 voucher is required for refund.",
      });
    }
    return returnValue;
  };

  handleVoucherID = (e) => {
    let checkVoucher = this.state.checkVoucher;
    let index;
    if (e.target.checked) {
      this.setState({ checkVoucherError: "" });
      checkVoucher.push(parseInt(e.target.value));
    } else {
      index = checkVoucher.indexOf(parseInt(e.target.value));
      checkVoucher.splice(index, 1);
    }
    this.setState({
      checkVoucher: checkVoucher,
      quantity: checkVoucher.length,
    });
  };

  render() {
    let siteData;

    try {
      siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    } catch (error) {
      console.error("Error parsing site data from localStorage:", error);
    }

    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let voucherRow;
    let voucherListData = this.state.voucherData ? this.state.voucherData : [];
    let sendRefundMailChecked =
      this.state.sendRefundMail == "yes" ? "true" : "";
    if (!isEmpty(voucherListData)) {
      voucherRow = voucherListData.map((voucher, index) => (
        <tr key={voucher.voucherID}>
          <td>{voucher.voucherNumber}</td>
          <td>{voucher.email} </td>
          <td>{voucher.dealText}</td>
          <td>{voucher.merchantName}</td>
          <td>
            {voucher.never_expires && voucher.never_expires == "1"
              ? voucher.expiryDate
              : moment(voucher.expiryDate).format("ll")}
          </td>
          <td> {voucher.createdOn ? moment(voucher.createdOn).format("ll") :moment(voucher.startDateTime).format("ll")  }


            
          </td>
          <td>
            {voucher.status}{" "}
            {voucher.status == "Redeemed"
              ? " At " + moment(voucher.redeemed_at).format("ll")
              : ""}
          </td>
          <td>{voucher.status == "Redeemed" ? voucher.redeemedBy : ""}</td>
          <td>
            <ButtonGroup>
              <DropdownButton title="Action" id="bg-nested-dropdown">
                {aclUtil.checkACL("CHANGE_STATUS") ? (
                  voucher.status == "Active" ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.changeStatus.bind(
                        this,
                        voucher.voucherID,
                        "Redeemed"
                      )}
                    >
                      <i className="glyphicon glyphicon-eye-open"></i> Redeem
                    </MenuItem>
                  ) : voucher.status == "Redeemed" ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.changeStatus.bind(
                        this,
                        voucher.voucherID,
                        "Active"
                      )}
                    >
                      <i className="glyphicon glyphicon-eye-open"></i> Active
                    </MenuItem>
                  ) : (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.changeStatus.bind(
                        this,
                        voucher.voucherID,
                        "Active"
                      )}
                    >
                      <i className="glyphicon glyphicon-eye-open"></i> Active
                    </MenuItem>
                  )
                ) : (
                  ""
                )}
                <MenuItem
                  eventKey={Math.random()}
                  onClick={() =>
                    window.open(
                      `/printarchiveVouchers/${voucher.voucherID}`,
                      "_blank"
                    )
                  }
                >
                  <i className="glyphicon glyphicon-print"></i> Print
                </MenuItem>

                {siteData.multi_lang === "yes" && (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      window.open(
                        `/printfrarchiveVouchers/${voucher.voucherID}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="glyphicon glyphicon-print"></i> French Print
                  </MenuItem>
                )}
                <MenuItem
                  eventKey={Math.random()}
                  onClick={() =>
                    window.open(
                      `/deals-detail/${voucher.deal_ID}/preview`,
                      "_blank"
                    )
                  }
                >
                  <i className="glyphicon glyphicon-eye-open"></i> Preview Deal
                </MenuItem>

                {aclUtil.checkACL("EDIT_VOUCHER") ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      window.open(
                        `/editarchiveVoucher/${voucher.voucherID}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="glyphicon glyphicon-pencil"></i> Edit
                  </MenuItem>
                ) : (
                  ""
                )}
                {aclUtil.checkACL("ADD_REMOVE_STORE_CREDIT") ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      window.open(
                        `/store-credit-preview/${voucher.userID}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="glyphicon glyphicon-plus"></i> Store Credit
                  </MenuItem>
                ) : (
                  ""
                )}
                {aclUtil.checkACL("REFUND_VOUCHER") ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.handleRefund.bind(this, voucher.voucherID)}
                  >
                    <i className="glyphicon glyphicon-usd"></i> Refund
                  </MenuItem>
                ) : (
                  ""
                )}
                {aclUtil.checkACL("ORDERS") ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      window.open(`/orders/${voucher.userID}`, "_blank")
                    }
                  >
                    <i className="glyphicon glyphicon-eye-open"></i> Order
                    History
                  </MenuItem>
                ) : (
                  ""
                )}
                <MenuItem
                  eventKey={Math.random()}
                  data-id={voucher.voucherID}
                  onClick={this.resendVoucher}
                >
                  <i className="glyphicon glyphicon-send"></i> Resend Voucher
                </MenuItem>
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list list-page ">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent
                path={this.state.path}
                links={this.state.links}
              />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Archive Vouchers List</h4>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="search"
                        onChange={this.handleSearch}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12"></div>
              </div>
            </header>
            <form onSubmit={this.handleSubmit}>
              <div className="panel">
                <div className="panel-body">
                  <Row>
                    <Col lg={3} md={6} xs={12}>
                      <ControlLabel>Date</ControlLabel>
                      <FormGroup controlId="formOfferTitle">
                        {this.state.range == false ? (
                          <DatePicker
                            onChange={this.onChangeStartDate}
                            value={this.state.startDate}
                          />
                        ) : (
                          <DateRangePicker
                            onChange={this.onChangeStartDateRange}
                            value={this.state.startDateRange}
                          />
                        )}
                      </FormGroup>
                    </Col>
                    <Col lg={3} md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          Offer IDs (separate by comma)
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="offerIDs"
                          value={this.state.offerIDs}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={3} md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          Merchant IDs (separate by comma)
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="merchantIDs"
                          value={this.state.merchantIDs}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={3} md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>User Email</ControlLabel>
                        <FormControl
                          type="text"
                          name="userEmail"
                          value={this.state.userEmail}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <Button bsStyle="info" type="submit" id="saveButton">
                        Submit
                      </Button>
                      {this.state.range == false ? (
                        <a
                          className="btn btn-success"
                          type="submit"
                          onClick={this.changeDatePicker}
                          id="saveButton"
                        >
                          Use Range
                        </a>
                      ) : (
                        <a
                          className="btn btn-success"
                          type="submit"
                          onClick={this.changeDatePicker}
                          id="saveButton"
                        >
                          Use Date
                        </a>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </form>
            <div className="panel-body">
              {this.state.show && this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={
                      this.state.msgType == "error"
                        ? "danger"
                        : this.state.msgType
                    }
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("voucherNumber")}>
                          Voucher Number{" "}
                          <span
                            className={this.state.voucherNumberSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        <th>Email </th>

                        <th onClick={this.handleSort("dealText")}>
                          Offer{" "}
                          <span
                            className={this.state.dealTextSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        <th>Merchant Name</th>
                        <th>Expiry Date </th>
                        <th>Order Date </th>
                        <th onClick={this.handleSort("status")}>
                          Status{" "}
                          <span
                            className={this.state.statusSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        <th>Redeemed By</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>{voucherRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps,
                      }) => (
                        <div className="pagination">
                          <button
                            className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange,
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange,
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map((page) => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666",
                              };
                            }
                            return (
                              <button
                                className="btn btn-default"
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange,
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange,
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange,
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.popUpStatus} onHide={this.ClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Add Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Note</ControlLabel>
              <FormControl
                type="text"
                value={this.state.note}
                placeholder="Enter Note"
                name="note"
                onChange={this.handleNoteChange}
                style={{ borderColor: this.state.noteError }}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleStatus}>
              Save
            </Button>
            <Button bsStyle="danger" onClick={this.ClosePopup}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.popUpTransfer} onHide={this.ClosePopupTransfer}>
          <Modal.Header closeButton>
            <Modal.Title>Transfer Voucher</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <InputGroup>
                <FormControl
                  type="text"
                  name="searchValue"
                  style={{ borderColor: this.state.searchValueError }}
                  value={this.state.searchValue}
                  onChange={this.handleSearch}
                />
                <InputGroup.Button>
                  <Button onClick={this.handleUserSearch}>
                    <i className="glyphicon glyphicon-search"></i> Search
                  </Button>
                </InputGroup.Button>
              </InputGroup>
            </FormGroup>
            <hr />
            {this.state.userList && (
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.userList.map((user, index) => (
                    <tr key={user.user_id}>
                      <td>{user.firstName}</td>
                      <td>{user.lastName}</td>
                      <td>{user.email}</td>
                      <td>
                        <Button
                          bsSize="xsmall"
                          bsStyle="warning"
                          onClick={this.transferVoucher.bind(
                            this,
                            user.user_id
                          )}
                        >
                          {" "}
                          Transfer
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.ClosePopupTransfer}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.popUpRefund}
          bsSize="large"
          onHide={this.CloseRefundPopup}
        >
          <Modal.Header closeButton>
            <Modal.Title>Refund Voucher</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12} xs={12}>
                <b>Transactions</b>
              </Col>
              <Col md={12} xs={12}>
                <hr />
              </Col>
              <Col md={12} xs={12}>
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Qty.</th>
                      <th>Transaction ID</th>
                      <th>Base Price</th>
                      <th>Charged To Card</th>
                      <th>Credit Used</th>
                      <th>Discount</th>
                      <th>Payment Method</th>
                      <th>Last 4CC</th>
                      <th>Date Ordered</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.transactions &&
                      this.state.transactions.map((data, index) => (
                        <tr key={`transactions${index}`}>
                          <td>{++index}</td>
                          <td>{data.quantity}</td>
                          <td>{data.payment_id}</td>
                          <td>
                            {localStorage.getItem("symbol")}
                            {data.amount}
                          </td>
                          <td>
                            {localStorage.getItem("symbol")}
                            {(
                              parseFloat(data.amount) -
                              parseFloat(data.store_credit_amount)
                            ).toFixed(2)}
                          </td>
                          <td>
                            {localStorage.getItem("symbol")}
                            {parseFloat(data.store_credit_amount)}
                          </td>
                          <td>
                            {localStorage.getItem("symbol")}
                            {data.discount ? data.discount : "0.00"}
                          </td>
                          <td>
                            {data.paymentMethod ? data.paymentMethod : "FREE"}
                          </td>
                          <td>{data.cardNumber}</td>
                          <td>{data.created_on}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </Col>
              <Col md={12} xs={12}>
                <b>Vouchers</b>
              </Col>
              <Col md={12} xs={12}>
                <hr />
              </Col>
              <Col md={12} xs={12}>
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Void?</th>
                      <th>Voucher #</th>
                      <th>Transaction ID</th>
                      <th>Print Count</th>
                      <th>Status</th>
                      <th>Date Orderd</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.vouchers &&
                      this.state.vouchers.map((data, index) => (
                        <tr key={`vouchers${index}`}>
                          <td>
                            {data.status == "Active" ? (
                              <FormGroup>
                                {this.state.checkVoucher.indexOf(
                                  data.voucherID
                                ) > -1 ? (
                                  <Checkbox
                                    inline
                                    checked={true}
                                    onChange={this.handleVoucherID}
                                    value={data.voucherID}
                                  ></Checkbox>
                                ) : (
                                  <Checkbox
                                    inline
                                    onChange={this.handleVoucherID}
                                    value={data.voucherID}
                                  ></Checkbox>
                                )}
                              </FormGroup>
                            ) : (
                              <FormGroup>
                                <Checkbox inline disabled={true}></Checkbox>
                              </FormGroup>
                            )}
                          </td>
                          <td>{data.voucherNumber}</td>
                          <td>{data.transaction_id}</td>
                          <td>{data.print_count}</td>
                          <td>{data.status}</td>
                          <td>{data.createdOn}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </Col>

              <Col md={6} xs={12}>
                <Row>
                  <Col md={12} xs={12}>
                    <h3>Refunds</h3>
                  </Col>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                  <Col md={12} xs={12}>
                    {this.state.voucherDetail &&
                    this.state.voucherDetail.refund.length > 0 ? (
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>Type</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.voucherDetail.refund.length > 0 ? (
                            this.state.voucherDetail.refund.map(
                              (data, index) => (
                                <tr>
                                  <td>{data.amount}</td>
                                  <td>{data.paymentMethod}</td>
                                  <td>{data.refunded_on}</td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={3}>No refunds have been issued.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      "No refunds have been issued."
                    )}
                  </Col>
                </Row>
              </Col>
              <Col md={6} xs={12}>
                <Row>
                  <Col md={12} xs={12}>
                    <h3>Credit User</h3>
                  </Col>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                  <Col md={12} xs={12} className="text-danger">
                    {this.state.checkVoucherError !== "" && (
                      <Row>
                        <Col md={12} xs={12}>
                          {this.state.checkVoucherError}
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col md={12} xs={12}>
                    <Row>
                      <Col md={4} xs={12}>
                        Amount:
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup controlId="formBasicText">
                          <FormControl
                            type="text"
                            placeholder="Amount"
                            onChange={this.handleChange}
                            name="amount"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup controlId="formBasicText">
                          <FormControl
                            componentClass="select"
                            name="refundAs"
                            value={this.state.refundAs}
                            onChange={this.handleChange}
                          >
                            <option value="StoreCredit">As Store Credit</option>
                            {this.state.authStatus == true && (
                              <option value="CreditCard">Authorize.net</option>
                            )}
                            {this.state.payPalStatus == true && (
                              <option value="Paypal">Paypal</option>
                            )}
                            {this.state.chaseStatus == true && (
                              <option value="Chase">Chase</option>
                            )}
                            {this.state.paywayStatus == true && (
                              <option value="paywayPaymentMethod">
                                PaywayWS
                              </option>
                            )}
                            {this.state.stripeStatus == true && (
                              <option value="Stripe">Stripe</option>
                            )}
                            <option value="OfflineRefund">
                              Offline Refund
                            </option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4} xs={12}>
                        Reason:
                      </Col>
                      <Col md={8} xs={12}>
                        <FormGroup controlId="formControlsTextarea">
                          <FormControl
                            componentClass="textarea"
                            name="reason"
                            value={this.state.reason}
                            onChange={this.handleChange}
                            placeholder="Reason"
                            style={{ borderColor: this.state.reasonError }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={8} xs={12}>
                        Number of Vouchers being Refunded:
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup controlId="formBasicText">
                          <FormControl
                            type="number"
                            name="quantity"
                            readonly="readonly"
                            value={this.state.quantity}
                            onChange={this.handleChange}
                            style={{ borderColor: this.state.quantityError }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12} xs={12}>
                        <Radio
                          name="refundtype"
                          defaultChecked={
                            this.state.refundtype == "instock" ? true : ""
                          }
                          value="instock"
                          onClick={this.handleChange}
                        >
                          Restock the quantity
                        </Radio>
                      </Col>
                      <Col md={12} xs={12}>
                        <Radio
                          name="refundtype"
                          defaultChecked={
                            this.state.refundtype == "notinstock" ? true : ""
                          }
                          value="notinstock"
                          onClick={this.handleChange}
                        >
                          Do not restock the quantity
                        </Radio>
                      </Col>
                      <Col md={12} xs={12}>
                        <Checkbox
                          className="checkBox"
                          name="sendRefundMail"
                          checked={sendRefundMailChecked}
                          value={this.state.sendRefundMail}
                          onChange={this.handleCheck}
                          inline
                        >
                          Send refund email to customer
                        </Checkbox>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.refundProcess}>
              Refund
            </Button>
            <Button bsStyle="danger" onClick={this.CloseRefundPopup}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userList: state.subAdminReducer.userList,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  archivevoucherlist: state.voucherReducer.archivevoucherlist,
  voucherStatus: state.voucherReducer.voucherStatus,
  paymentSetting: state.paymentSettingReducer.paymentSetting,
  transfer: state.voucherReducer.transfer,
  voucherDetails: state.voucherReducer.voucherDetails,
  refundStatus: state.voucherReducer.refundStatus,
  error: state.voucherReducer.error,
  resendStatus: state.voucherReducer.resendStatus,
});

export default withRouter(
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    updateStatus,
    getFrontPaymentSetting,
    getArchivevoucherList,
    allUser,
    voucherTransfer,
    getVoucherDetail,
    refundVoucher,
    resendarchiveVoucher,
  })(ArchivevouchersList)
);



// WEBPACK FOOTER //
// ./src/app/views/admin/voucher/ArchivevouchersList.js